module.exports = __webpack_public_path__ + "img/zhihu.da1f8e09.svg";